function fn_libs_reload() {
    var $masonry = $(document).find("[data-masonry-grid]"),
        $lightgallery = $(document).find(".comp_gallery [data-gallery]");
    
    if ($masonry.length) {
        $masonry.masonry().masonry('reloadItems');
        $masonry.masonry().masonry('layout');
    }
    if ($lightgallery) {
        fn_comp_gallery_lightgallery($lightgallery);
    }

    sr.sync();
}